import { render, staticRenderFns } from "./MaterialsView.vue?vue&type=template&id=54bf89aa&scoped=true&"
import script from "./MaterialsView.vue?vue&type=script&lang=js&"
export * from "./MaterialsView.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsView.vue?vue&type=style&index=0&id=54bf89aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bf89aa",
  null
  
)

export default component.exports